export default __webpack_public_path__ + "static/1-small-d1bcac6cc7a6db4b0c82d903c5d2eb58.jpg";